import * as React from "react"

import { cn } from "@/lib/utils/ui"
import styles from "./badge.module.css"

type BadgeVariant = "default" | "secondary" | "destructive" | "outline"

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: BadgeVariant
}

const variantClassMap: Record<BadgeVariant, string> = {
  default: styles.default,
  secondary: styles.secondary,
  destructive: styles.destructive,
  outline: styles.outline,
}

function Badge({ className, variant = "default", ...props }: BadgeProps) {
  return (
    <div
      className={cn(styles.root, variantClassMap[variant], className)}
      {...props}
    />
  )
}

export { Badge }
export type { BadgeVariant }
